<script>
  // Toolbar trigger + dropdown for picking which app occupies the left-panel
  // app slot (see #src/stores/ui.js:leftPanelMode). Registry-driven off
  // APPS/toggleApp (./apps.js) so a new app needs no changes here.
  import { Popover, clickOutside, tooltip } from "svelte-utilities";
  import ShapexXIcon from "@local/assets/icons/shapex-x.svg";
  import { APPS, toggleApp } from "./apps.js";
  import { leftPanelMode } from "#src/stores/ui.js";

  let anchor;
  let open = false;

  function selectApp(id) {
    $leftPanelMode = toggleApp($leftPanelMode, id);
    open = false;
  }
</script>

<div class="apps-menu" bind:this={anchor}>
  <!-- Always full-strength and bordered so it reads as an enabled button;
       the open state shows as an active highlight, never as dimming. The X
       mark is the only ShapeX mark in the chrome, sized below the nav logo so
       it doesn't compete with it. -->
  <button
    type="button"
    class="apps-trigger"
    class:active={$leftPanelMode !== null}
    use:tooltip={{ text: "Apps" }}
    on:click={() => (open = !open)}>
    <span class="apps-x-icon"><ShapexXIcon /></span>
    <span class="apps-trigger-label">Apps</span>
  </button>

  {#if open}
    <Popover container={anchor}>
      <div
        class="apps-menu-list"
        use:clickOutside={[anchor]}
        on:outclick={() => (open = false)}>
        {#each APPS as app (app.id)}
          <button class="apps-menu-row" on:click={() => selectApp(app.id)}>
            <span class="apps-menu-check">{$leftPanelMode === app.id ? "✓" : ""}</span>
            <span>{app.label}</span>
          </button>
        {/each}
      </div>
    </Popover>
  {/if}
</div>

<style lang="scss">
  .apps-menu {
    display: flex;
    align-items: center;
  }

  .apps-trigger {
    @apply flex items-center gap-1.5 px-2 py-1 rounded cursor-pointer;
    @apply border border-gray-600 text-gray-200;

    &:hover {
      @apply bg-gray-700;
    }

    // Open state = the app's normal active-button highlight, not dimming.
    &.active {
      @apply bg-gray-700 border-gray-500;
    }
  }

  .apps-x-icon {
    display: flex;
    align-items: center;
    line-height: 0;

    // Sized a touch under the nav logo (~22px) so the two marks don't compete.
    :global(svg) {
      width: 15px;
      height: 15px;
    }
  }

  .apps-trigger-label {
    @apply text-xs font-semibold text-gray-200 whitespace-nowrap;
  }

  .apps-menu-list {
    @apply p-1 rounded drop-shadow-lg border border-gray-700;
    @apply bg-black text-xs text-gray-200 flex flex-col gap-0.5 z-50;
    min-width: 140px;
  }

  .apps-menu-row {
    all: unset;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    padding: 0.375rem 0.5rem;
    border-radius: 0.25rem;
    white-space: nowrap;

    &:hover {
      @apply bg-gray-700;
    }
  }

  .apps-menu-check {
    display: inline-block;
    width: 0.9rem;
    flex: none;
  }
</style>
